import { Action, AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { ThunkAction } from 'redux-thunk';

import agents from './Agents';
import webChatConfiguration from './Config';
import conversationEvents, { agentTypingIndicator } from './Conversation';
import error from './Error';
import notifications from './Notifications';
import widgetConfiguration from './Widget';

const reducers = combineReducers({
  agents,
  agentTypingIndicator: agentTypingIndicator.reducer,
  conversationEvents,
  error,
  notifications,
  webChatConfiguration,
  widgetConfiguration,
});

export type AppState = ReturnType<typeof reducers>;

export type AppThunk<ThunkReturnType = void> = ThunkAction<
  ThunkReturnType,
  AppState,
  unknown,
  Action<string>
>;

export type AppAsyncThunk<ThunkReturnType = any> = ThunkAction<
  Promise<ThunkReturnType>,
  AppState,
  unknown,
  Action<string>
>;

export type AppDispatch = ThunkDispatch<AppState, any, AnyAction>;

export default reducers;
